import { useCallback, useContext } from 'react';

import { TrackingContext } from 'context/Tracking';

const STORAGE_KEY = 'mfaPromptDismissedUntil';
const DISMISSAL_DURATION_DAYS = 7;
const DISMISSAL_DURATION_MS = DISMISSAL_DURATION_DAYS * 24 * 60 * 60 * 1000;

export { DISMISSAL_DURATION_DAYS };

export function useMfaPromptDismissal() {
  const [, { faro }] = useContext(TrackingContext);

  const isDismissed = useCallback((): boolean => {
    try {
      const dismissedUntil = localStorage.getItem(STORAGE_KEY);
      if (!dismissedUntil) {
        return false;
      }

      const dismissedUntilDate = new Date(dismissedUntil);
      const now = new Date();

      // Clean up if expired
      if (now >= dismissedUntilDate) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
      }

      return true;
    } catch (err) {
      faro.trackError(err as Error);
      console.error('Error checking MFA prompt dismissal:', err);
      return false;
    }
  }, [faro]);

  const dismissPrompt = useCallback(() => {
    try {
      const dismissUntil = new Date(Date.now() + DISMISSAL_DURATION_MS);
      localStorage.setItem(STORAGE_KEY, dismissUntil.toISOString());
    } catch (err) {
      faro.trackError(err as Error);
      console.error('Error dismissing MFA prompt:', err);
    }
  }, [faro]);

  const clearDismissal = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      faro.trackError(err as Error);
      console.error('Error clearing MFA prompt dismissal:', err);
    }
  }, [faro]);

  return {
    isDismissed,
    dismissPrompt,
    clearDismissal,
  };
}
